export enum PortPlanRevisionStatusCodes {
    Draft = 'D',
    Approved = 'A',
    Superseded = 'S'
}
